import { Flex } from "antd";
import { Button, Tooltip } from "@libertify/ui";
import { useTranslate } from "#src/hooks";
import {
  ArrowRightIcon,
  ArrowDownIcon,
  ArrowDownRightIcon,
  ArrowDownLeftIcon,
} from "@phosphor-icons/react";
import type { IconProps } from "@phosphor-icons/react";
import type { GradientDirection } from "./types";
import { GRADIENT_DIRECTIONS } from "./types";
import type { FC } from "react";

const DIRECTION_ICONS: Record<GradientDirection, FC<IconProps>> = {
  "left-right": ArrowRightIcon,
  "top-bottom": ArrowDownIcon,
  "diagonal-right": ArrowDownRightIcon,
  "diagonal-left": ArrowDownLeftIcon,
};

const ICON_SIZE = 14;

interface GradientDirectionButtonsProps {
  value: GradientDirection;
  onChange: (direction: GradientDirection) => void;
}

export const GradientDirectionButtons = ({
  value,
  onChange,
}: GradientDirectionButtonsProps) => {
  const t = useTranslate();

  return (
    <Flex gap={4} justify="center" wrap="wrap">
      {GRADIENT_DIRECTIONS.map((direction) => {
        const Icon = DIRECTION_ICONS[direction];
        return (
          <Tooltip
            key={direction}
            content={t(
              `components.templates.settings.colorPicker.gradientDirection.${direction}`
            )}
          >
            <Button
              variant={value === direction ? "primary" : "secondary"}
              icon={<Icon size={ICON_SIZE} />}
              onClick={() => onChange(direction)}
              aria-label={direction}
              style={{ width: 24, height: 24, padding: 0 }}
            />
          </Tooltip>
        );
      })}
    </Flex>
  );
};
